// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"4e14f367","271":"93afb672","321":"87be9cfc","574":"1befd030","744":"8a2e488f"}[chunkId] + ".chunk.js";
};